// extracted by mini-css-extract-plugin
module.exports = {"modal":"OfflineBookingModal_modal__Y8COI"};